import axios from 'axios';
import Qs from 'qs';
import Vue from 'vue';
import { Message } from 'element-ui'; // 消息提示框组件

// 环境的切换
if (process.env.NODE_ENV == 'development') {
    // console.log('process.env.NODE_ENV', process.env.NODE_ENV)
    // axios.defaults.baseURL = 'http://172.20.60.100:8089';
    axios.defaults.baseURL = 'https://www.ivecohk.com'
} else if (process.env.NODE_ENV == 'debug') {
    // axios.defaults.baseURL = 'http://172.20.60.100:8089';
    axios.defaults.baseURL = 'https://www.ivecohk.com'
} else if (process.env.NODE_ENV == 'production') {
    // axios.defaults.baseURL = 'http://172.20.60.100:8089';
    // axios.defaults.baseURL = 'https://sz.seasaw.cn:9929';
    axios.defaults.baseURL = 'https://www.ivecohk.com'
};

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;

function startLoading() {
    loading = Vue.prototype.$loading({
        lock: true,
        text: 'Loading...',
        background: 'rgba(255, 255, 255, 0.9)',
        // customClass: 'loading'
        target: document.querySelector('.loading') //设置加载动画区域
    });
}

function endLoading() {
    setTimeout(() => {
        loading.close();
    }, 200)
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }
    needLoadingRequestCount++;
};

function tryHideFullScreenLoading() {
    // console.log('needLoadingRequestCount', needLoadingRequestCount)
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    // console.log('needLoadingRequestCount', needLoadingRequestCount)
    if (needLoadingRequestCount === 0) {
        endLoading();
    }
};

// 设置请求超时时间
axios.defaults.timeout = 10000;

// 设置post请求头
var urlencoded = axios.create({
    headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' }
});
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';


// 请求拦截
axios.interceptors.request.use(config => {
    // if (config.method === 'post') {
    //     config.data = Qs.stringify(config.data);
    // }
    showFullScreenLoading();
    return config;
}, (error) => {
    // 对请求错误做些什么
    // tryHideFullScreenLoading();
    Message.error({ message: '請求超時!' });
    return Promise.error(error);
})

// 响应拦截
axios.interceptors.response.use(response => {
    // 对响应数据做点什么
    tryHideFullScreenLoading();
    if (response.status == 200) {
        return response;
    }
}, error => {
    return Promise.reject(error);
});


// 封装get方法和post方法

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
                tryHideFullScreenLoading();
                Loading.service(true).close();
                //  Message({message: '请求成功', type: 'success'});
            })
            .catch(err => {
                reject(err.data)
                    //  Loading.service(true).close();
                tryHideFullScreenLoading();
                Message({ message: '數據加載失敗, "刷新重试"或"聯系管理員"', type: 'error' });
            })
    });
}

/** 
 * post方法，对应postform请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function postform(url, params) {
    // console.log('url1', url)
    // console.log('params1', params)
    return new Promise((resolve, reject) => {
        urlencoded.post(url, Qs.stringify(params))
            .then(res => {
                // console.log('ress', res)
                resolve(res.data);
                tryHideFullScreenLoading();
                // Loading.service(true).close();
                //  Message({message: '请求成功', type: 'success'});
            })
            .catch(err => {
                console.log('err', err)
                reject(err.data)
                tryHideFullScreenLoading();
                // Loading.service(true).close();
                Message({ message: '數據加載失敗, "刷新重试"或"聯系管理員"', type: 'error' });
            })
    });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    // console.log('url2', url)
    // console.log('params2', params)
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                // console.log('res', res)
                resolve(res.data);
                tryHideFullScreenLoading();
                //  Loading.service(true).close();
                //  Message({message: '请求成功', type: 'success'});
            })
            .catch(err => {
                console.log('err', err)
                reject(err.data)
                tryHideFullScreenLoading();
                //  Loading.service(true).close();
                Message({ message: '數據加載失敗, "刷新重试"或"聯系管理員"', type: 'error' });
            })
    });
}


// WEBPACK FOOTER //
// ./src/untils/axios.js